import { Grid } from "@mui/material";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomSelect from "../../components/Form/CustomSelect";
import Helpers from "../../helpers/helpers";
import { useEffect, useState } from "react";
import LoadingDialog from "../../components/Common/LoadingDialog";

export default function LocationInfoForm({ formObj, handleFormChange, error, postcodeRef, handleGetRegionByPostcode, regionList, stateList, countryList }) {
    const [loading, setLoading] = useState(false);

    const handlePostcode = (text) => {
        handleFormChange('postal_code', text);
        setTimeout(() => {
            if (text === postcodeRef.current) {
                handleGetRegionByPostcode();
                setLoading(true);
            }
        }, Helpers.searchInterval);
    }

    useEffect(() => {
        if (regionList?.data?.length > 0 && formObj?.postal_code) {
            handleFormChange('region_id', regionList?.data?.map((region) => region.id));
        }
    }, [formObj?.postal_code, regionList])

    useEffect(() => {
        if (regionList?.code === "success" || regionList) {
            setLoading(false);
        }
    }, [regionList])

    return (
        <>
            <LoadingDialog open={loading} />
            <Grid container spacing={1}>
                <Grid item sm={12}>
                    <div className="text-semibold">Location</div>
                    <div className="subheader-2">Add your company address</div>
                </Grid>
                <Grid item sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.address_line_1}
                        onChange={(e) => handleFormChange('address_line_1', e)}
                        title={'Street address'}
                        placeholder={'Street address'}
                        error={error?.address_line_1}
                    />
                </Grid>
                <Grid item sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.address_line_2}
                        onChange={(e) => handleFormChange('address_line_2', e)}
                        title={'Apartment, building, floor, unit'}
                        placeholder={'Apartment, building, floor, unit, etc'}
                        isOptional={true}
                        error={error?.address_line_2}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.postal_code}
                        onChange={(e) => handlePostcode(e)}
                        title={'Postal Code'}
                        placeholder={'Postal Code'}
                        type={'number'}
                        error={error?.postal_code}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.region_id?.length > 0 ? formObj.region_id.map(id => regionList?.data?.find(region => region.id === id)?.name).filter(Boolean).join(', ') : ''}
                        // onChange={(e) => { console.log('helloooo', e, regionList?.data); handleFormChange('region', e) }}
                        title={'Region'}
                        placeholder={'Region'}
                        data={regionList?.data || []}
                        // labelName={'name'}
                        // valueName={'id'}
                        disabled={true}
                        error={error?.region}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.city_id}
                        // data={stateList?.find(state => state.id === formObj?.state_id)?.cities || []}
                        onChange={(e) => handleFormChange('city_id', e)}
                        title={'City'}
                        placeholder={'City'}
                        error={error?.city_id}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomSelect
                        values={formObj?.country_id || '-1'}
                        data={countryList || []}
                        onChange={(e) => handleFormChange('country_id', e)}
                        title={'Country'}
                        placeholder={'Country'}
                        labelName={'name'}
                        valueName={'id'}
                        error={error?.country_id}
                    />
                </Grid>
                <Grid item sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.google_map_link}
                        onChange={(e) => handleFormChange('google_map_link', e)}
                        title={'Google map link'}
                        isOptional={true}
                        placeholder={'Google map link'}
                        error={error?.google_map_link}
                    />
                </Grid>
            </Grid>
        </>

    )
}